// Foundations
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

// Services
import { CognitoService } from '../../../services/cognito.service';
import { LoadingIndicatorService } from 'src/app/services/loading-indicator.service';
import { AnalyticsService } from 'src/app/services/analytics.service';

// Components
import { PasswordFormComponent } from '../../_share/password-form/password-form.component';


@Component({
  selector: 'app-forgot-password-confirm',
  templateUrl: './forgot-password-confirm.component.html',
  styleUrls: ['./forgot-password-confirm.component.scss'],
})
export class ForgotPasswordConfirmComponent implements OnInit {
  @ViewChild('passwordForm', { static: false })
  passwordForm: PasswordFormComponent;

  @Input() email = '';

  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private snackBar: MatSnackBar,
    private conginitoService: CognitoService,
    private loadingIndicatorService: LoadingIndicatorService,
    private _analytics: AnalyticsService
  ) {
    this.form = this.fb.group({
      passwordForm: [],
      verificationCode: [
        '',
        { validators: [Validators.required, Validators.minLength(6)] },
      ],
    });
  }
  // Life cycles
  // ------------------------------------------------------------------------------------

  ngOnInit(): void {
    this._analytics.logScreen('signInForgotPasswordNewPasswordPage');
  }

  // Public Methods
  // ------------------------------------------------------------------------------------

  get f(): any {
    return this.form.controls;
  }

  onSubmit(): void {
    this._analytics.logButtonTap('signInForgotPasswordNewPassword_submit');

    const {
      verificationCode,
      passwordForm: { password },
    } = this.form.value;
    this.loadingIndicatorService.show();
    this.conginitoService
      .confirmPassword(this.email, verificationCode, password)
      .pipe(finalize(() => this.loadingIndicatorService.hide()))
      .subscribe((status) => {
        if (status.result === 'SUCCESS') {
          this.snackBar.open('Password successfully updated.', '', {
            duration: 2000,
          });
          this.router.navigate(['/sign-in']);
        } else {
          if (status.result === 'CodeMismatchException') {
            this.snackBar.open('Incorrect verification code.', '', {
              duration: 2000,
            });
          } else {
            this.snackBar.open(status.message, '', { duration: 2000 });
          }
          this.form.reset();
          this.passwordForm.form.reset();
        }
      });
  }
}
